export default __webpack_public_path__ + "static/media/22.5c95f7e3.jpg";